import type { DeepPartial } from '@luna/utils-ts';

import type { Trading } from '../../types';

export const tradingConfigCZ: DeepPartial<Trading> = {
    applyIdAsQueryParam: true,
    applyOrderTypeModal: true,
    applyValidFromForSell: true,
    defaultAmountPrecision: 7,
    loadBidAskPriceFromQuotes: true,
    shouldLoadTradingDocuments: true,
    shouldPrefillOrderTypeLimit: true,
    showAllMarketPlaces: true,
    showOrderTypeInfo: true,
    showTargetPortfolio: true,
    tradingValidationStrategies: {
        accountTradeableStatus: true,
    },
    validUntilBasedOnLimitType: true,
    review: {
        url: 'www.csas.cz',
        investmentCenterUrl: 'www.investicnicentrum.cz',
    },
};
